angular.module('bmsApp.sm.schedule', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.sm.schedule', {
					url: '^/sm/schedule?date',
					views: {
						'main@main': {
							templateUrl: 'ng/sm/schedule/templates/Schedule.html',
							controller: 'SMScheduleCtrl'
						}
					},
					ncyBreadcrumb: { label: 'Schedule' }
				})

			;

		}]);
